import { removeReactionApi } from 'api/messengerReactions/removeReactionApi'
import { Reaction } from 'reducers/messenger/ChatMessengerState'

export const REMOVE_REACTION = 'REMOVE_REACTION' as const

export const removeReactionAction = (
  messageUuid: string,
  reaction: Reaction,
  profileId: number
) => ({
  type: REMOVE_REACTION,
  promise: () => removeReactionApi(messageUuid, reaction.id),
  messageUuid,
  reaction,
  profileId,
})
